/* eslint-disable @typescript-eslint/prefer-for-of */
const getMetaTag = (name: string) => {
  const metas = document.getElementsByTagName("meta");
  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute("name") === name) {
      return metas[i];
    }
  }
  return null;
};

const getMetaContent = (name: string) => {
  const metaTag = getMetaTag(name);
  if (!metaTag) return null;
  return metaTag.getAttribute("content");
};

type Callback = (token: string) => void;
const gRecaptchaExecute = (cb: Callback) => {
  const recaptchaKey = getMetaContent("recaptchaKey");
  grecaptcha.ready(() => {
    grecaptcha.execute(recaptchaKey, { action: "submit" }).then(cb);
  });
};

export { gRecaptchaExecute };
